<form role="search" (ngSubmit)="search()">
  <input
    type="search"
    placeholder="Keresés"
    [formControl]="searchControl"
    [matAutocomplete]="auto"
  />
  <button mat-stroked-button type="submit">
    <mat-icon>search</mat-icon>
  </button>
  <mat-autocomplete #auto="matAutocomplete">
    <mat-option
      *ngFor="let suggestion of suggestions$ | async"
      [value]="suggestion.value"
      (click)="search()"
      class="suggestion-option"
    >
      <mat-icon class="me-2">{{
        suggestion.searched ? "schedule" : "search"
      }}</mat-icon>
      <span
        [innerHTML]="
          suggestion.value
            | highlightByStart
              : suggestion.firstMatchingIndex ?? 0
              : searchControl.value?.length ?? 0
        "
      ></span>
    </mat-option>
  </mat-autocomplete>
</form>
